import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import HeaderTwo from "../../../../components/header/HeaderTwo";
import FaqThree from "../../../../components/faq/FaqThree";
import CopyRightTwo from "../../../../components/footer/CopyRightTwo";
import FooterTwo from "../../../../components/footer/FooterTwo";
// import Pricing from "../../../../components/pricing/pricing-one/Pricing";
import CallToActionThree from "../../../../components/call-to-action/CallToActionThree";
import Pricing from "../../../../components/pricing/pricing-one/Pricing";


const PricingClientCtrl = () => {
  return (
    <div className="main-page-wrapper p0">
      <Helmet>
        <title>Pricing | ClientCtrl</title>
        <meta
          name="description"
          content="Find the best pricing options and save thousands of dollars. Budget-friendly pricing designed to meet the needs of every business."
        />
      </Helmet>
      {/* End Page SEO Content */}

      <HeaderTwo />
      {/* End Header */}

      {/* =============================================
				Pricing Section Two
			==============================================  */}
      <div className="pricing-section-two pricing-section-two-custom">
        <div className="fancy-hero-four">
          <div className="shapes shape-one"></div>
          <div className="shapes shape-two"></div>
          <div className="shapes shape-three"></div>
          <div className="shapes shape-four"></div>
          <div className="shapes shape-five"></div>
          <div className="shapes shape-six"></div>
          <div className="bg-wrapper">
            <div className="container">
              <div className="row">
                <div className="col-xl-10 col-lg-11 m-auto">
                  <h2>Our Best Pricing</h2>
                </div>
                <div className="col-12 m-auto">
                  <p className="font-rubik sub-heading">
                    Budget-friendly pricing designed to meet the needs of every
                    business
                  </p>
                </div>
              </div>
              {/* End .row */}
            </div>
            {/* End .container */}
          </div>
          {/*  /.bg-wrapper */}
        </div>
        {/* /.fancy-hero-four */}

        <div className="container">
          <div className="pricing-table-area">
            <div className="tab-content">
              
              <Pricing/>
            </div>
            <img
              src="images/shape/64.svg"
              alt="shape"
              className="shapes shape-one"
            />
          </div>
          {/*  /.pricing-table-area  */}
        </div>
      </div>
      <br />
      {/* /.pricing-section-two  */}

      {/* 	=============================================
				Fancy Text block Seven
			==============================================  */}
      <div className="fancy-text-block-seven mt-10 md-mt-60">
        <div className="bg-wrapper no-bg">
          <img
            src="images/shape/29.svg"
            alt="shape"
            className="shapes shape-one"
          />
          <img
            src="images/shape/30.svg"
            alt="shape"
            className="shapes shape-two"
          />
          <img
            src="images/shape/31.svg"
            alt="shape"
            className="shapes shape-three"
          />
          <img
            src="images/shape/32.svg"
            alt="shape"
            className="shapes shape-four"
          />
          <img
            src="images/shape/33.svg"
            alt="shape"
            className="shapes shape-five"
          />
          <div className="container">
            <div className="row">
              <div
                className="col-lg-4 col-md-5 col-sm-10 m-auto"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <div className="m1">
                  <img
                    src="images/assets/riskfree.jpg"
                    style={{ borderRadius: "80%" }}
                    alt="media"
                  />
                  <img
                    src="images/shape/34.svg"
                    alt="shape"
                    className="shapes shape-six"
                  />
                </div>
              </div>
              <div
                className="col-xl-5 col-lg-7 ms-auto"
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <div className="quote-wrapper pt-60">
                  <blockquote className="font-rubik">
                    {/* ClientCtrl GUARANTEE */}
                    100% SATISFACTION GUARANTEE
                  </blockquote>
                  <h6 className="mt-20">
                    {/* if not satisfied in 14 days, get your money back, no strings attached */}
                    If you are not completely satisfied within 14 days, we offer
                    a full refund with no conditions attached.
                  </h6>
                </div>
                {/* /.quote-wrapper */}
              </div>
            </div>
            <br />
            <br />
            <div className="row">
              <div
                className="col-lg-5 col-md-5 ms-auto"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <div className="quote-wrapper pt-60">
                  <blockquote className="font-rubik">
                    LOOKING FOR <br />
                    SELF HOSTED?
                  </blockquote>
                  <h6 className="mt-20">
                    <span style={{ color: "black", fontWeight: "500" }}>
                      ClientCtrl STANDARD can now be hosted on your own server
                    </span>
                  </h6>{" "}
               
                  <p className="m-2">Setup Charges: ₹3,249 ($39) </p>
                  <div className="m-3 w-75">
                    <div className="d-flex flex-column w-75">
                      <div className="row d-flex align-items-center">
                        <p className="col-6 fs-6" style={{ color: "black", fontWeight: "500" }}>From INDIA ?</p>
                        <button
                          type="button"
                          class="col-6 ms-0 btn btn-primary" style={{ backgroundColor: "#072654"}}
                        >
                          <a href="https://rzp.io/i/xyM5T8x">₹ Buy Now</a>
                        </button>
                      </div>
                      <div className="row mt-3 align-items-center">
                        <p className="col-6 fs-6" style={{ color: "black", fontWeight: "500" }}>Others</p>
                        <button
                          type="button"
                          class="col-6 ms-0 btn btn-warning "
                        >
                          <a href="https://www.paypal.com/ncp/payment/GJS43P5PNVYZS">
                            $ Buy Now
                          </a>
                        </button>
                      </div>
                    </div>
                  </div>
                  <h6 className="mt-5">
                    <span style={{ color: "black", fontWeight: "500" }}>
                      Add-on: Yearly Support
                    </span>
                  </h6>
                 
                  <p className="m-2">
                    From 2<sup>nd</sup> year onwards: ₹4,899 ($59)
                  </p>
                </div>
                {/* /.quote-wrapper */}
              </div>
              <div
                className="col-xl-7 col-lg-8 col-sm-12 m-auto"
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <div className="m1">
                  <img src="images/assets/selfhosted.jpg" alt="media" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*  /.bg-wrapper */}
      </div>
      {/* /.fancy-text-block-seven */}

      {/* /.useable-tools-section-two */}

      {/* 	=====================================================
				FAQ Section
			===================================================== */}
      <div className="faq-section">
        <div className="container">
          <div className="title-style-two text-center mb-30 md-mb-30">
            <p>FAQ</p>
            <h2>Question & Answer</h2>
          </div>
          {/* /.title-style-one */}

          <div className="row">
            <div className="col-xl-9 col-lg-10 m-auto">
              <FaqThree />
            </div>
          </div>
          {/* /.row */}

          <div
            className="text-center more-faq-meta mt-75 md-mt-50"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            <h3 className="mb-35 font-rubik">Don’t find your answer?</h3>
            <Link to="/contact">Contact us</Link>
          </div>
        </div>
      </div>
      {/* End .faq-section */}

      {/* 	=====================================================
			Fancy Short Banner Three
			===================================================== */}
      <div className="fancy-short-banner-three mt-80 md-mt-80">
        <div className="container">
          <div className="bg-wrapper">
            <CallToActionThree />
          </div>
          {/* /.bg-wrapper */}
        </div>
        {/* /.container */}
      </div>
      {/* /.fancy-short-banner-four */}

      {/* 	=====================================================
				Footer Style Two
			===================================================== */}
      <footer className="theme-footer-two pt-120 md-pt-70">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
          {/* /.container */}
        </div>
        {/* /.top-footer */}

        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
          {/*  /.bottom-footer */}
        </div>
      </footer>
      {/* /.theme-footer-one */}
    </div>
  );
};

export default PricingClientCtrl;
